import { url } from 'inspector/promises';
import { BaseService } from '../..//service/base';
import { PaginatedFetcher } from '../../service/paginatedFetcher';
import { GradingDTO } from '../grading_tab/grading_service';
import { DataCache } from '../../components/cachedFetch';

export interface SpreaderSummaryDataDTO {
    assetId: string;
    startTimeUTC: number;
    endTimeUTC: number;
    pulseCount: number;
}

export interface LatestSpreaderDataDTO {
    assetId: string;
    value: number;
    key: number;
}

export interface SpreaderDataDTO {
    assetId: string;
    solidMode: number;
    solidActualRate: number;
    solidSetRate: number;
    seasonalSolid: number[];
    seasonalPrewet: number[];
    seasonalAntiice: number[];
    lat: number;
    lng: number;
    timestamp: number;
}

export class SpreaderService extends BaseService {
    fetcher!: PaginatedFetcher<SpreaderDataDTO> | null;

    summaryDataCache!: DataCache<SpreaderSummaryDataDTO[]>;
    private summaryDataKey?: string;

    async getLatest() {
        const response = await this.get<LatestSpreaderDataDTO[]>(this.url + '/api/' + this.orgid + '/spreader/latest');
        return response;
    }

    public getSpreadingData(
        startUTC: number,
        endUTC: number,
        assetList: string[],
        onPageLoaded: (data: SpreaderDataDTO[]) => void,
        onComplete: () => void,
        onStatus: (page: number, totalPages: number) => void
    ): void {
        const url = '/spreader/trackdata?start=' + startUTC + '&end=' + endUTC + '&assets=' + assetList.join(',');
        this.fetcher = new PaginatedFetcher<SpreaderDataDTO>(url, 500);

        this.fetcher.fetchAllPagesComplete(
            (data: SpreaderDataDTO[], page: number, totalPages: number) => {
                onPageLoaded(data);
                onStatus(page, totalPages);
            },
            () => {
                console.log('Completed fetching spreading data');
                onComplete();
            }
        );
    }

    getSummaryData(startUTC: number, endUTC: number) {
        const key = `${startUTC}:${endUTC}`;

        if (!this.summaryDataCache || this.summaryDataKey !== key) {
            this.summaryDataKey = key;
            this.summaryDataCache = new DataCache<SpreaderSummaryDataDTO[]>(() => this.fetchSummaryData(startUTC, endUTC), 10000);
        }
        return this.summaryDataCache.get();
    }

    async fetchSummaryData(startUTC: number, endUTC: number): Promise<SpreaderSummaryDataDTO[]> {
        const response = await fetch(this.url + '/api/' + this.orgid + '/spreader/summary?start=' + startUTC + '&end=' + endUTC, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + this.jwt,
            },
        });
        return response.json();
    }
}
